module.exports = __webpack_public_path__ + "static/media/Jim Seibert Headshot.e0864317.jpeg";